// These styles MUST be set in Google Cloud Console if a mapId is set.
// I'm leaving them here just in case we lose them, in order to restore them quickly.
// const styles: google.maps.MapTypeStyle[] = [
//   {
//     featureType: "administrative.land_parcel",
//     elementType: "labels",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "landscape",
//     elementType: "geometry.fill",
//     stylers: [
//       {
//         color: "#e9e9e9",
//       },
//     ],
//   },
//   {
//     featureType: "poi",
//     elementType: "labels.text",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "poi.business",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "road",
//     elementType: "geometry.fill",
//     stylers: [
//       {
//         color: "#ffffff",
//       },
//       {
//         visibility: "on",
//       },
//     ],
//   },
//   {
//     featureType: "road",
//     elementType: "geometry.stroke",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "road",
//     elementType: "labels.icon",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "road.arterial",
//     elementType: "labels",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "road.highway",
//     elementType: "labels",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "road.local",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "road.local",
//     elementType: "labels",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "transit",
//     stylers: [
//       {
//         visibility: "off",
//       },
//     ],
//   },
//   {
//     featureType: "water",
//     elementType: "geometry.fill",
//     stylers: [
//       {
//         color: "#9dc2c2",
//       },
//     ],
//   },
// ];

export const mapOptions: google.maps.MapOptions = {
  // styles, // see comment on top of this file
  disableDefaultUI: true,
  minZoom: 3,
  mapId: process.env.GATSBY_STORE_LOCATOR_GOOGLE_MAP_ID,
  restriction: {
    latLngBounds: {
      east: Number.MAX_SAFE_INTEGER,
      north: 85,
      south: -85,
      west: -Number.MAX_SAFE_INTEGER,
    },
  },
};
